import { Add, Check, Clear, Remove, RemoveShoppingCart } from '@mui/icons-material';
import { Box, Button, ButtonGroup, Card, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { cloneDeep } from 'lodash';
import { useContext, useState } from "react";
import { BasketContext } from '../../contexts/BasketContext';
import { ReturnContext } from '../../contexts/ReturnContext';
import { IBasketItem } from '../../interfaces';
import { BasketDispatchDialog } from '../BasketDispatchDialog';
import { BasketReturnDialog } from '../BasketReturnDialog';
import { BreadcrumbBar } from '../Breadcrumb';
import { ResultOptionsWidget } from '../Dashboard/ResultOptionsWidget';
import { SearchResult } from '../SearchResult';

export const Basket: React.FC<{ returnBasket?: boolean }> = ({ returnBasket }) => {

    const targetContext = useContext(returnBasket === true ? ReturnContext : BasketContext);

    const [confirmDelete, setConfirmDelete] = useState<string | null>(null);

    const onUpdateQuantity = (item: IBasketItem, subtract?: boolean) => {


        let updatedItem = cloneDeep(item)

        if (subtract === true) {

            if (updatedItem.requestedQuantity === 1) {
                //if quantity would drop to zero
                //prompt to remove the item instead
                setConfirmDelete(updatedItem.id);
                return;
            }

            updatedItem.requestedQuantity--;
        } else {
            updatedItem.requestedQuantity++;
        }

        let updatedBasket = cloneDeep(targetContext.basket);

        updatedBasket.items = updatedBasket.items.map(x => {
            if (x.id === updatedItem.id)
                return updatedItem;
            else return x;
        });

        targetContext.setBasket(updatedBasket);
    }

    const onRemoveItem = (item: IBasketItem) => {
        let updatedBasket = cloneDeep(targetContext.basket);

        updatedBasket.items = updatedBasket.items.filter(x => x.id !== item.id);
        targetContext.setBasket(updatedBasket);

    }

    const isMaximumQuantity = (x: IBasketItem) => {

        let total = x.materialGroup.materials?.reduce((sum, a) => sum + (a.quantity ?? 0), 0) ?? 0;

        if (x.requestedQuantity >= total)
            return true;

        return false;
    }



    return (<div>
        <BreadcrumbBar
            current={returnBasket ? "Returns Basket" : "Basket"}
            previous={[]}
        />
        <Box display="none" marginTop={2}>
            <ResultOptionsWidget />
        </Box>
        <Grid container spacing={2} marginTop={2}>
            {targetContext.basket.items.map(x => {
                return <Grid container spacing={2} key={x.id}>
                    <Grid item xs={10}>
                        <SearchResult
                            materialGroup={x.materialGroup}
                            disableAddToBasket={true}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Card >
                            <Box sx={{ height: "64px" }} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                                {
                                    confirmDelete === x.id ?
                                        <>
                                            <Typography
                                                variant="subtitle2"
                                            >Remove from Basket?</Typography>
                                            <ButtonGroup>
                                                <IconButton
                                                    color="error"
                                                    onClick={() => onRemoveItem(x)}
                                                >
                                                    <Check />
                                                </IconButton>
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => setConfirmDelete(null)}
                                                >
                                                    <Clear />
                                                </IconButton>
                                            </ButtonGroup>

                                        </>
                                        :
                                        <ButtonGroup>
                                            <Tooltip title="requested quantity">
                                                <Button
                                                    variant="text"
                                                    size="small"
                                                >
                                                    <strong>{x.requestedQuantity}</strong>
                                                </Button>
                                            </Tooltip>
                                            <Tooltip title="decrease quantity">
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => onUpdateQuantity(x, true)}
                                                >
                                                    <Remove />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="increase quantity">
                                                <span>
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => onUpdateQuantity(x, false)}
                                                        disabled={isMaximumQuantity(x)}
                                                    >
                                                        <Add />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Tooltip title="remove from basket">
                                                <IconButton
                                                    color="error"
                                                    onClick={() => setConfirmDelete(x.id)}
                                                >
                                                    <RemoveShoppingCart />
                                                </IconButton>
                                            </Tooltip>
                                        </ButtonGroup>

                                }
                            </Box>
                        </Card>
                    </Grid>

                </Grid>
            })}

            {targetContext.basket.items.length === 0 &&
                <Box
                    width="100%"

                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ opacity: .4, my: "25vh" }}
                >
                    <Typography variant="h1" color="primary">
                        <RemoveShoppingCart fontSize="inherit" />
                    </Typography>

                    <Typography variant="body2" color="GrayText" >{returnBasket && "Returns "} Basket is empty.</Typography>

                </Box>
            }


            <Grid container spacing={2} sx={{ opacity: targetContext.basket.items.length > 0 ? 1 : 0, marginTop: 'auto' }}>
                <Grid item xs={10} />
                <Grid item xs={2}>
                    <Card >
                        <Box sx={{ height: "88px" }} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            {
                                returnBasket ? <BasketReturnDialog /> : <BasketDispatchDialog />
                            }
                        </Box>


                    </Card>
                </Grid>

            </Grid>
        </Grid>
    </div >);
}